import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'

(function($) {
  const header = $('.header')
  let scrollY = window.scrollY

  // show/hide header menu when clicking the Menu toggle
  $('.header__menu-toggle').on('click', function() {
    $(this).blur()
    header.toggleClass('header--show');

    if (header.hasClass('header--show')) {
      disableBodyScroll(header.find('.header__menu'))
    } else {
      enableBodyScroll(header.find('.header__menu'))
    }
  })

  // offset certain sections by the header height (logo actually)
  function offsetElements() {
    const logo = $('.header__logo-wrap')
    const bcr = logo[0].getBoundingClientRect()
    $('.offset-by-header').css({
      'padding-top': bcr.top + bcr.height
    })
  }

  // set offset initially
  offsetElements()

  // resize Header logo if it's in animation end state
  function resizeLogoWrapper() {
    if (header.hasClass('animation--end')) {
      header.find('.header__logo-wrap').css({
        width: Math.ceil(header.find('.e')[0].getBoundingClientRect().width + 1)
      })
    }
  }

  // resize logo initially
  resizeLogoWrapper()

  // and then debounce on resize
  window.addEventListener('resize', debounce(offsetElements, 100))
  window.addEventListener('resize', debounce(resizeLogoWrapper, 100))

  // make Header slide up/down based on the scroll direction
  window.addEventListener('scroll', throttle(onWindowScroll, 100));

  // debounced check for header position 200ms from the last scroll event
  window.addEventListener('scroll', debounce(onWindowScroll, 100));

  function onWindowScroll() {
    const newScrollY = Math.max(0, window.scrollY)
    if (newScrollY === scrollY) {
        return false
    } else if (newScrollY > scrollY) {
        header.addClass('header--scroll-up')
    } else {
        header.removeClass('header--scroll-up')
    }
    scrollY = newScrollY;
  }

})(jQuery);
